// extracted by mini-css-extract-plugin
export var center = "internalReleasePage-module--center--O73Uo";
export var date = "internalReleasePage-module--date--7kx8r";
export var left = "internalReleasePage-module--left--Qq+Q5";
export var mainImageContainer = "internalReleasePage-module--mainImageContainer---1ICS";
export var premiseliftcontainer = "internalReleasePage-module--premiseliftcontainer--7Rlp-";
export var premiselifttextarea = "internalReleasePage-module--premiselifttextarea--frtE+";
export var premiselifttextareacontainer = "internalReleasePage-module--premiselifttextareacontainer--KLtZ5";
export var right = "internalReleasePage-module--right---Hd0a";
export var titleContainer = "internalReleasePage-module--titleContainer--6JLQd";